var _style, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoNormal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{font-family:'AlverataSb';}\n\t.st3{font-size:32.9409px;}\n\t.st4{display:inline;fill:none;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:none;}\n\t.st7{fill:url(#SVGID_1_);}\n\t.st8{fill:url(#SVGID_00000019637546320083451820000008285447516696001457_);}\n\t.st9{fill:url(#SVGID_00000106141151818527366680000013061241282870481083_);}\n\t.st10{fill:url(#SVGID_00000029035082577314083540000001220424522466338989_);}\n\t.st11{fill:url(#SVGID_00000029020741210293181320000002913194236837415580_);}\n\t.st12{fill:url(#SVGID_00000104695247253940528790000017197874431107604669_);}\n\t.st13{fill:url(#SVGID_00000047018163203204301330000011786808623014167424_);}\n\t.st14{fill:url(#SVGID_00000000901934631262022330000006681507321280051636_);}\n\t.st15{fill:url(#SVGID_00000044136107283512463630000003295572582678768311_);}\n\t.st16{fill:url(#SVGID_00000156559105021697749310000004601084488992411821_);}\n\t.st17{fill:url(#SVGID_00000062907031123012341340000005106859047069237120_);}\n\t.st18{fill:url(#SVGID_00000035497087613453680500000016419893320769624746_);}\n\t.st19{fill:url(#SVGID_00000099652073695241180870000013619150028540082617_);}\n\t.st20{fill:url(#SVGID_00000116955601003614640700000015840680880223006370_);}\n\t.st21{fill:url(#SVGID_00000016039074435304302800000009907848489675579529_);}\n\t.st22{fill:url(#SVGID_00000020357080700708427720000007110261471443201180_);}\n\t.st23{fill:url(#SVGID_00000054960591920523102420000016353374353964718747_);}\n\t.st24{fill:url(#SVGID_00000058586501433077777520000004611408454193176222_);}\n\t.st25{fill:url(#SVGID_00000015356306181976352220000015037901920273181101_);}\n\t.st26{fill:url(#SVGID_00000161629529632558706510000009942835467280270977_);}\n\t.st27{fill:url(#SVGID_00000127045279680032116620000009371422596071585199_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 35.8663 226.2084)",
    className: "st1 st2 st3"
  }, "CLAIM SPHERE"), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M91.28,146.09c0.06,0,0.11-0.01,0.17-0.01c-0.13,0-0.26,0-0.39,0C91.14,146.08,91.21,146.09,91.28,146.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M121.91,95.39c4.62,1.61,9.38,1.83,14.2,1.27c6.37-0.74,12.33-2.71,17.76-6.15c3.61-2.29,6.76-5.09,8.65-9.03 c1.33-2.77,1.61-5.62,0.26-8.48c-1.05-2.22-2.81-3.75-4.93-4.9c-3.9-2.11-8.14-2.7-12.49-2.75c-1.04-0.01-2.07,0.06-3.1,0.14 c-6.61,0.55-12.79,2.45-18.47,5.88c-3.61,2.18-6.76,4.87-8.87,8.61c-2.17,3.85-2.02,7.96,0.47,11.08 C117.09,93.19,119.37,94.51,121.91,95.39z M121.16,77.75c1.62-2.76,4.02-4.7,6.74-6.26c4.63-2.64,9.63-3.96,14.41-4.02 c3.28,0.02,5.94,0.39,8.44,1.52c2.42,1.1,4.37,2.68,4.97,5.44c0.47,2.16-0.18,4.09-1.33,5.89c-1.94,3.02-4.75,5.04-7.9,6.61 c-4.52,2.26-9.32,3.38-14.38,3.23c-2.78-0.08-5.48-0.59-7.96-1.94c-2.2-1.2-3.8-2.88-4.18-5.46 C119.73,80.95,120.26,79.3,121.16,77.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M132.77,81.8c3.53,0.8,6.77-0.03,9.79-1.89c0.81-0.5,1.51-1.15,2.07-1.93c1.53-2.11,0.98-4.22-1.38-5.3 c-1.15-0.53-2.37-0.68-3.62-0.66c-3.23,0.08-6.17,0.96-8.59,3.2c-1.18,1.09-1.98,2.41-1.5,4.06 C129.98,80.84,131.32,81.47,132.77,81.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M91.3,129.78c-0.06,0-0.11,0.01-0.17,0.01c0.13,0,0.26-0.01,0.39,0C91.44,129.79,91.37,129.78,91.3,129.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.47,94.55c1.25,3.87,4.05,6.4,7.54,8.24c5,2.64,10.43,3.45,16,3.54c3.13,0.05,6.25-0.25,9.34-0.79 c8.41-1.48,16.23-4.4,23.16-9.46c3.92-2.86,7.29-6.25,9.35-10.74c1.25-2.72,1.8-5.57,1.14-8.55c-0.88-3.93-3.35-6.67-6.66-8.73 c0,0-4.3-3.6-18.72-4.24c-9.71-0.43-21.31,4.71-21.31,4.71c-2.65,1.12-5.17,2.51-7.58,4.08c-4.33,2.83-8.15,6.19-10.73,10.76 C106.01,86.88,105.19,90.6,106.47,94.55z M114.92,79.98c2.11-3.74,5.26-6.43,8.87-8.61c5.68-3.43,11.86-5.33,18.47-5.88 c1.03-0.09,2.06-0.15,3.1-0.14c4.35,0.05,8.59,0.63,12.49,2.75c2.12,1.15,3.88,2.68,4.93,4.9c1.35,2.86,1.07,5.71-0.26,8.48 c-1.89,3.95-5.03,6.74-8.65,9.03c-5.43,3.45-11.38,5.41-17.76,6.15c-4.82,0.56-9.58,0.34-14.2-1.27c-2.54-0.88-4.82-2.2-6.52-4.33 C112.9,87.94,112.75,83.83,114.92,79.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.54,115.18c3.49,3.25,7.68,5.21,12.19,6.53c7.32,2.15,14.8,2.49,22.36,1.79 c7.22-0.67,14.22-2.3,20.99-4.88c8.99-3.43,17.17-8.15,23.78-15.28c2.68-2.89,4.9-6.1,6.27-9.82c2.33-6.3,1.72-12.2-2.61-17.5 c-2.56-3.13-5.87-5.29-9.54-6.92c-0.29-0.13-0.58-0.25-0.87-0.38c3.42,3.1,6.27,9.51,6.02,14.2c-0.2,3.84-1.71,7.18-3.89,10.25 c-4.09,5.76-9.62,9.83-15.8,13.04c-7.94,4.13-16.39,6.55-25.31,7.35c-6,0.54-11.93,0.29-17.77-1.26c-4.68-1.24-9-3.17-12.38-6.78 c-3.18-3.4-4.47-7.42-3.8-12.04c0.57-3.93,2.43-7.26,4.86-10.32c0.61-0.77,1.27-1.5,1.91-2.26c-1.16,0.78-2.04,1.83-2.95,2.84 c-3.24,3.57-6.16,7.36-7.91,11.92C94.3,102.94,95.89,109.91,101.54,115.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.05,134.87c0.06,0.23,0.1,0.45,0.14,0.68c1.26,0.68,2.56,1.3,3.9,1.85c7,2.88,14.37,3.94,21.88,4.12 c4.46,0.1,8.9-0.23,13.31-0.86c8.2-1.16,16.14-3.29,23.78-6.51c9.66-4.08,18.46-9.43,25.58-17.27c1.91-2.11,3.61-4.35,5.01-6.77 c-1.04-4.45,0.52-8.93,3.72-11.8c0.2-3.9-0.72-7.69-2.97-11.33c-2.14-3.44-5.15-6.08-8.12-8.74c-0.25-0.22-0.48-0.53-1.08-0.6 c0.38,0.4,0.61,0.64,0.84,0.89c2.93,3.2,4.71,6.92,4.99,11.28c0.28,4.41-0.94,8.47-3.06,12.29c-2.85,5.14-6.8,9.33-11.42,12.87 c-13.42,10.29-28.8,15.28-45.5,16.48c-5.62,0.4-11.25,0.13-16.81-0.99c-5.51-1.11-10.79-2.84-15.42-6.13 c-6.57-4.67-9.92-10.86-8.7-19.1c0.14-0.92,0.37-1.83,0.56-2.74c-0.04-0.02-0.09-0.03-0.13-0.05c-0.18,0.44-0.37,0.88-0.54,1.33 c-0.98,2.55-1.68,5.19-2.24,7.86c-1.08,5.19-0.41,9.96,2.08,14.28C97.7,126.51,101.78,130.02,103.05,134.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.66,94.58c-0.12,0.44,0.08,0.68,0.19,0.93c0.12,0.3,0.23,0.6,0.33,0.89c0.13-0.06,0.26-0.11,0.39-0.17 C203.28,95.69,202.97,95.14,202.66,94.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.18,129.87c0.1-0.01,0.19-0.02,0.29-0.03C90.37,129.85,90.27,129.85,90.18,129.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.52,123.99c0,0.64,0.02,1.29,0.03,1.93c0.1-0.01,0.2-0.03,0.3-0.04C89.74,125.25,89.63,124.62,89.52,123.99 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.73,118.77c-3.85,5.55-8.75,10.05-14.29,13.83c-15.02,10.22-31.76,15.3-49.81,16.25 c-6.06,0.32-12.11-0.09-18.08-1.36c-4.94-1.05-9.68-2.56-14-5.03c-0.22,0.55-0.47,1.1-0.78,1.62c-0.89,1.52-2.08,2.79-3.47,3.77 c3.76,3.24,8.15,5.42,12.88,6.98c9.82,3.25,19.91,3.81,30.14,2.87c5.73-0.52,11.38-1.53,16.93-3.06 c13.78-3.79,26.46-9.71,37.08-19.51c4.17-3.85,7.71-8.21,10.14-13.38c0.38-0.8,0.7-1.62,1.01-2.43c-2.33-0.39-4.47-1.45-6.17-3 C199.8,117.15,199.29,117.97,198.73,118.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.46,120.82c-0.7,4.55-2.57,8.62-5.13,12.39c-4.09,6.03-9.41,10.81-15.37,14.91 c-8.44,5.79-17.7,9.83-27.52,12.64c-7.62,2.18-15.4,3.46-23.32,3.78c-4.16,0.17-8.32,0.04-12.47-0.45 c-5.85-0.69-11.54-1.99-16.94-4.38c-4.71-2.09-8.89-4.91-12.16-8.97c-0.36-0.45-0.69-0.93-1.01-1.41 c-0.17,0.06-0.36,0.11-0.54,0.17c0.63,1.37,1.34,2.7,2.02,4.05c3.04,6.05,7.86,10.16,13.87,13.01c7.07,3.35,14.6,4.78,22.34,5.16 c5.72,0.28,11.42,0,17.09-0.85c11.81-1.78,23.02-5.36,33.48-11.17c7.57-4.21,14.37-9.39,19.75-16.28c3.04-3.89,5.3-8.17,6.39-13.04 c0.82-3.66,0.51-7.34,0.32-11.01c-0.21,0.03-0.41,0.05-0.62,0.07C209.59,119.89,209.53,120.36,209.46,120.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208.14,139.92c-1.04,2.79-2.44,5.39-4.17,7.8c-3.99,5.56-9.01,10.05-14.72,13.74 c-14.67,9.49-30.8,14.25-48.23,14.71c-5.68,0.15-11.3-0.3-16.85-1.6c-6.02-1.41-11.68-3.62-16.56-7.55 c-0.05-0.04-0.15-0.02-0.33-0.05c0.15,0.19,0.23,0.3,0.33,0.4c5.28,5.41,11.42,9.37,18.82,11.3c8.4,2.2,16.9,2.49,25.47,1.46 c10.89-1.32,21.22-4.48,30.9-9.66c5.43-2.91,10.38-6.46,14.78-10.79c4.82-4.75,8.01-10.45,10.01-16.87 c0.36-1.17,0.7-2.35,1.04-3.53c-0.07-0.02-0.13-0.05-0.2-0.07C208.32,139.45,208.23,139.68,208.14,139.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.94,180.21c-12.15,3.24-24.38,3.94-36.67,0.45c0.15,0.07,0.29,0.16,0.45,0.22 c8.2,3.08,16.65,4.27,25.38,3.42c5.91-0.58,11.66-1.9,17.25-3.91c9.99-3.59,18.44-9.36,25.21-17.56c0.15-0.18,0.37-0.33,0.35-0.72 C188.05,171.48,177.1,176.97,164.94,180.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.17,88.23c2.48,1.35,5.18,1.86,7.96,1.94c5.06,0.14,9.87-0.98,14.38-3.23c3.14-1.57,5.95-3.59,7.9-6.61 c1.15-1.8,1.8-3.73,1.33-5.89c-0.6-2.76-2.55-4.34-4.97-5.44c-2.5-1.13-5.16-1.51-8.44-1.52c-4.78,0.06-9.78,1.37-14.41,4.02 c-2.72,1.55-5.13,3.5-6.74,6.26c-0.91,1.54-1.44,3.2-1.17,5.01C120.37,85.36,121.97,87.03,124.17,88.23z M131.04,75.22 c2.42-2.24,5.36-3.12,8.59-3.2c1.25-0.02,2.47,0.13,3.62,0.66c2.36,1.09,2.91,3.19,1.38,5.3c-0.56,0.77-1.25,1.43-2.07,1.93 c-3.02,1.86-6.26,2.69-9.79,1.89c-1.45-0.33-2.79-0.96-3.24-2.52C129.06,77.63,129.86,76.31,131.04,75.22z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 208.31,
    cy: 107.34,
    r: 7.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 91.32,
    cy: 137.97,
    r: 7.67
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.4036,
    y1: 202.3662,
    x2: 46.4036,
    y2: 226.2832
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3492,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DADADA"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M49.15,226.28c-9.36,0-11.73-5.96-11.73-11.63c0-8.14,4.41-12.29,11.96-12.29c4.28,0,6,0.96,6,0.96 s-0.07,0.72-0.07,2.5c0,1.58,0.07,2.64,0.07,2.64c-1.42-2.04-2.6-3.23-5.67-3.23c-3.99,0-7.18,2.87-7.18,9.26 c0,5.3,1.88,8.9,7.05,8.9c3.1,0,4.38-1.25,5.8-3.29c0,0-0.07,1.05-0.07,2.87c0,1.61,0.07,2.37,0.07,2.37 S53.21,226.28,49.15,226.28z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052795187135737627660000008506303315491000767_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.6243,
    y1: 202.5635,
    x2: 65.6243,
    y2: 226.0859
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3492,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DADADA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052795187135737627660000008506303315491000767_)"
    },
    d: "M72.31,224.9l-0.07,1.15H61.11 c-1.78,0-2.54,0.03-2.54,0.03l0.3-0.56c0.66-1.25,0.82-1.48,0.82-11.37c0-9.59-0.13-9.72-0.82-11.04l-0.3-0.56 c0,0,0.99,0.07,3.59,0.07c2.57,0,3.52-0.07,3.52-0.07l-0.33,0.56c-0.73,1.25-0.89,1.78-0.89,10.05v10.01h2.37 c4.08,0,4.61-0.96,5.83-2.73C72.67,220.45,72.51,221.74,72.31,224.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034804725122154990320000014675504270968939950_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.3511,
    y1: 202.6299,
    x2: 84.3511,
    y2: 226.0859
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3492,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DADADA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034804725122154990320000014675504270968939950_)"
    },
    d: "M91.65,226.02 c-2.17,0-3.89,0.07-3.89,0.07c0.43-0.3,1.05-0.86,1.05-2.08c0-1.09-0.49-2.83-1.05-4.94l-0.46-1.65h-6.98l-0.46,1.65 c-0.56,2.11-1.09,3.85-1.09,4.94c0,1.22,0.66,1.78,1.09,2.08c0,0-1.35-0.07-3.39-0.07c-2.11,0-3.29,0.07-3.29,0.07 c1.25-1.19,1.85-3.23,3.2-7.81l4.05-13.74c0.13-0.39,0.23-0.79,0.23-1.22c0-0.46-0.2-0.66-0.23-0.69h8.3c0,0.03-0.2,0.23-0.2,0.69 c0,0.43,0.1,0.82,0.2,1.22l3.76,13.74c1.25,4.61,1.84,6.62,3.06,7.81C95.54,226.09,94.02,226.02,91.65,226.02z M84.43,206.48 c-0.36-1.38-0.56-2.17-0.59-2.41c-0.03,0.17-0.23,0.89-0.63,2.41l-2.14,8.07h5.5L84.43,206.48z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004506320756934422910000013019988030222480541_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.1174,
    y1: 202.5635,
    x2: 101.1174,
    y2: 226.0859
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3492,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DADADA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004506320756934422910000013019988030222480541_)"
    },
    d: "M101.13,226.02 c-2.47,0-3.52,0.07-3.52,0.07l0.3-0.56c0.66-1.25,0.82-1.48,0.82-11.37c0-9.59-0.13-9.72-0.82-11.04l-0.3-0.56 c0,0,0.99,0.07,3.49,0.07c2.57,0,3.52-0.07,3.52-0.07l-0.3,0.56c-0.66,1.25-0.82,1.48-0.82,11.37c0,9.59,0.13,9.72,0.82,11.04 l0.3,0.56C104.63,226.09,103.57,226.02,101.13,226.02z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093886090338431180900000006282723161940121002_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.7507,
    y1: 202.5635,
    x2: 120.7507,
    y2: 226.0859
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3492,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DADADA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093886090338431180900000006282723161940121002_)"
    },
    d: "M129.5,226.02 c-2.47,0-3.59,0.07-3.59,0.07l0.33-0.56c0.63-1.19,0.82-1.58,0.82-11.37v-7.77c-0.07,0.16-0.46,1.68-1.19,3.29l-5.77,13.31 l-5.67-13.24c-0.72-1.65-1.19-3.1-1.25-3.33v8.07c0,9.59,0.13,9.72,0.82,11.04l0.3,0.56c0,0-0.96-0.07-2.8-0.07 c-1.88,0-2.87,0.07-2.87,0.07l0.3-0.56c0.63-1.25,0.82-1.48,0.82-11.37c0-9.59-0.13-9.72-0.82-11.04l-0.3-0.56 c0,0,1.32,0.07,3.85,0.07c2.34,0,3.43-0.07,3.43-0.07l4.32,10.05c0.4,0.86,0.46,1.25,0.46,1.25s0.07-0.33,0.46-1.25l4.35-10.05 c0,0,1.25,0.07,3.62,0.07c2.47,0,3.72-0.07,3.72-0.07l-0.3,0.56c-0.66,1.22-0.82,1.48-0.82,11.37c0,9.59,0.13,9.72,0.82,11.04 l0.3,0.56C132.86,226.09,131.94,226.02,129.5,226.02z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103987863155107358230000005976423725608201097_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.4346,
    y1: 202.3662,
    x2: 151.4346,
    y2: 226.2832
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3492,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DADADA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103987863155107358230000005976423725608201097_)"
    },
    d: "M150.18,226.28 c-4.08,0-6.06-0.99-6.06-0.99s0.07-0.79,0.07-2.37c0-1.75-0.07-2.93-0.07-2.93c1.25,1.81,2.73,3.33,5.83,3.33 c2.11,0,4.32-0.43,4.32-2.93c0-1.81-1.09-2.54-2.6-3.43l-2.8-1.68c-2.44-1.42-4.71-3.1-4.71-6.62c0-3.89,2.57-6.29,8.04-6.29 c3.69,0,5.67,0.96,5.67,0.96s-0.07,0.79-0.07,2.44c0,1.71,0.07,2.77,0.07,2.77c-1.35-1.98-2.87-3.23-5.47-3.23 c-1.81,0-3.79,0.4-3.79,2.67c0,1.71,1.19,2.37,3,3.43l2.34,1.38c2.77,1.61,4.81,3.13,4.81,6.85 C158.75,224.74,155.06,226.28,150.18,226.28z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177467223229820867190000013162548748631127685_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.853,
    y1: 202.5312,
    x2: 170.853,
    y2: 226.0859
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3492,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DADADA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177467223229820867190000013162548748631127685_)"
    },
    d: "M170.41,217.16 c-1.25,0-2.34-0.17-2.34-0.17c0,6.59,0.16,7.21,0.89,8.5l0.33,0.59c0,0-1.02-0.07-3.56-0.07c-2.47,0-3.49,0.07-3.49,0.07l0.3-0.56 c0.66-1.22,0.82-1.48,0.82-11.37c0-9.59-0.13-9.72-0.82-11.04l-0.3-0.56c0,0,1.05,0.07,2.77,0.07c1.42,0,3.69-0.1,4.71-0.1 c3.53,0,9.75,0.23,9.75,7.05C179.47,216.1,174.33,217.16,170.41,217.16z M169.62,205.17c-0.89,0-1.55,0.03-1.55,0.03v9.26 c0,0,0.36,0.1,1.75,0.1c4.42,0,4.61-3.1,4.61-4.91C174.43,205.63,171.66,205.17,169.62,205.17z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106846893395980697100000012803365329424415114_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.0547,
    y1: 202.5635,
    x2: 193.0547,
    y2: 226.0859
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3492,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DADADA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106846893395980697100000012803365329424415114_)"
    },
    d: "M200.05,226.02 c-2.47,0-3.52,0.07-3.52,0.07l0.3-0.56c0.59-1.19,0.82-1.52,0.82-9.88h-9.19c0,8.4,0.13,8.63,0.82,9.88l0.3,0.56 c0,0-1.05-0.07-3.49-0.07c-2.47,0-3.52,0.07-3.52,0.07l0.3-0.56c0.66-1.25,0.82-1.48,0.82-11.37c0-9.59-0.13-9.72-0.82-11.04 l-0.3-0.56c0,0,0.99,0.07,3.49,0.07c2.6,0,3.53-0.07,3.53-0.07l-0.3,0.56c-0.63,1.15-0.82,1.45-0.82,9.22h9.19 c0-7.74-0.2-8.01-0.82-9.22l-0.3-0.56c0,0,0.99,0.07,3.49,0.07c2.6,0,3.52-0.07,3.52-0.07l-0.3,0.56 c-0.66,1.22-0.82,1.48-0.82,11.37c0,9.59,0.13,9.72,0.82,11.04l0.3,0.56C203.55,226.09,202.49,226.02,200.05,226.02z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134207375954538051210000012988931575060411521_",
    gradientUnits: "userSpaceOnUse",
    x1: 215.2075,
    y1: 202.5635,
    x2: 215.2075,
    y2: 226.0859
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3492,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DADADA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134207375954538051210000012988931575060411521_)"
    },
    d: "M222.46,224.9l-0.07,1.15h-12.25 c-1.78,0-2.54,0.03-2.54,0.03l0.3-0.56c0.66-1.25,0.82-1.48,0.82-11.37c0-9.59-0.13-9.72-0.82-11.04l-0.3-0.56 c0,0,0.72,0.03,2.5,0.03h11.96c0,0-0.03,0.63-0.03,2.08c0,1.58,0.07,2.31,0.07,2.37c-0.03-0.03-0.23-0.33-1.15-0.89 c-0.79-0.46-2.08-0.72-3.62-0.72h-3.85v7.45h3.06c1.55,0,2.83-0.16,3.62-0.63c0.86-0.49,1.12-0.79,1.19-0.86 c0,0.03-0.1,0.96-0.1,2.93c0,1.88,0.1,2.83,0.1,2.9c-0.03-0.03-0.26-0.33-1.19-0.89c-0.79-0.46-2.08-0.63-3.62-0.63h-3.06v7.48 h3.53c4.08,0,4.61-0.96,5.83-2.73C222.82,220.45,222.65,221.74,222.46,224.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138551492400979742490000012116595096787693477_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.1899,
    y1: 202.5635,
    x2: 236.1899,
    y2: 226.25
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3492,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DADADA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138551492400979742490000012116595096787693477_)"
    },
    d: "M243.27,226.25 c-2.57,0-3.59-0.86-5.17-3.56l-2.01-3.36c-1.71-2.83-2.08-3.52-3.53-3.52c-0.3,0-0.53,0.03-0.53,0.03c0,8.1,0.16,8.43,0.82,9.69 l0.3,0.56c0,0-1.02-0.07-3.39-0.07s-3.43,0.07-3.43,0.07l0.3-0.56c0.63-1.22,0.82-1.48,0.82-11.37c0-9.59-0.13-9.72-0.82-11.04 l-0.3-0.56c0,0,1.15,0.07,2.77,0.07c1.02,0,3.26-0.07,4.38-0.07c4.61,0,9.65,0.26,9.65,6c0,3.99-2.73,6.33-6.88,6.36 c2.57,0.36,3.59,1.61,5.14,4.35l1.71,3.16c0.99,1.75,1.68,2.8,2.93,3.36C246.04,225.79,245.51,226.25,243.27,226.25z  M233.46,205.13c-0.86,0-1.42,0.07-1.42,0.07v8.04c0,0,0.49,0.03,1.61,0.03c0.49,0,1.32-0.07,1.88-0.17 c1.52-0.33,2.67-1.55,2.67-3.95C238.2,205.66,236.26,205.13,233.46,205.13z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035502595835969164800000003039509062822890926_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.0317,
    y1: 202.5635,
    x2: 255.0317,
    y2: 226.0859
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3492,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DADADA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035502595835969164800000003039509062822890926_)"
    },
    d: "M262.28,224.9l-0.07,1.15h-12.25 c-1.78,0-2.54,0.03-2.54,0.03l0.3-0.56c0.66-1.25,0.82-1.48,0.82-11.37c0-9.59-0.13-9.72-0.82-11.04l-0.3-0.56 c0,0,0.72,0.03,2.5,0.03h11.96c0,0-0.03,0.63-0.03,2.08c0,1.58,0.07,2.31,0.07,2.37c-0.03-0.03-0.23-0.33-1.15-0.89 c-0.79-0.46-2.08-0.72-3.62-0.72h-3.85v7.45h3.06c1.55,0,2.83-0.16,3.62-0.63c0.86-0.49,1.12-0.79,1.19-0.86 c0,0.03-0.1,0.96-0.1,2.93c0,1.88,0.1,2.83,0.1,2.9c-0.03-0.03-0.26-0.33-1.19-0.89c-0.79-0.46-2.08-0.63-3.62-0.63h-3.06v7.48 h3.53c4.08,0,4.61-0.96,5.83-2.73C262.64,220.45,262.48,221.74,262.28,224.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M91.3,145.94c0.06,0,0.11-0.01,0.17-0.01c-0.13,0-0.26,0-0.39,0C91.15,145.93,91.22,145.94,91.3,145.94z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M132.78,81.65c3.53,0.8,6.77-0.03,9.79-1.89c0.81-0.5,1.51-1.15,2.07-1.93c1.53-2.11,0.98-4.22-1.38-5.3 c-1.15-0.53-2.37-0.68-3.62-0.66c-3.23,0.08-6.17,0.96-8.59,3.2c-1.18,1.09-1.98,2.41-1.5,4.06 C129.99,80.68,131.33,81.32,132.78,81.65z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M91.31,129.63c-0.06,0-0.11,0.01-0.17,0.01c0.13,0,0.26-0.01,0.39,0C91.45,129.63,91.38,129.63,91.31,129.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098907944953254271640000013168549809957158332_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.7546,
    y1: 96.1257,
    x2: 188.4808,
    y2: 96.1257
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E9B69C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#FBD9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    style: {
      stopColor: "#8F9A9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098907944953254271640000013168549809957158332_)"
    },
    d: "M101.55,115.03 c3.49,3.25,7.68,5.21,12.19,6.53c7.32,2.15,14.8,2.49,22.36,1.79c7.22-0.67,14.22-2.3,20.99-4.88c8.99-3.43,17.17-8.15,23.78-15.28 c2.68-2.89,4.9-6.1,6.27-9.82c2.33-6.3,1.72-12.2-2.61-17.5c-2.56-3.13-5.87-5.29-9.54-6.92c-0.29-0.13-0.58-0.25-0.87-0.38 c3.42,3.1,6.27,9.51,6.02,14.2c-0.2,3.84-1.71,7.18-3.89,10.25c-4.09,5.76-9.62,9.83-15.8,13.04c-7.94,4.13-16.39,6.55-25.31,7.35 c-6,0.54-11.93,0.29-17.77-1.26c-4.68-1.24-9-3.17-12.38-6.78c-3.18-3.4-4.47-7.42-3.8-12.04c0.57-3.93,2.43-7.26,4.86-10.32 c0.61-0.77,1.27-1.5,1.91-2.26c-1.16,0.78-2.04,1.83-2.95,2.84c-3.24,3.57-6.16,7.36-7.91,11.92 C94.31,102.79,95.9,109.75,101.55,115.03z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075153093426334133010000014754028877811981737_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.2662,
    y1: 109.425,
    x2: 200.4077,
    y2: 109.425
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E9B69C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#FBD9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    style: {
      stopColor: "#8F9A9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075153093426334133010000014754028877811981737_)"
    },
    d: "M103.06,134.71 c0.06,0.23,0.1,0.45,0.14,0.68c1.26,0.68,2.56,1.3,3.9,1.85c7,2.88,14.37,3.94,21.88,4.12c4.46,0.1,8.9-0.23,13.31-0.86 c8.2-1.16,16.14-3.29,23.78-6.51c9.66-4.08,18.46-9.43,25.58-17.27c1.91-2.11,3.61-4.35,5.01-6.77c-1.04-4.45,0.52-8.93,3.72-11.8 c0.2-3.9-0.72-7.69-2.97-11.33c-2.14-3.44-5.15-6.08-8.12-8.74c-0.25-0.22-0.48-0.53-1.08-0.6c0.38,0.4,0.61,0.64,0.84,0.89 c2.93,3.2,4.71,6.92,4.99,11.28c0.28,4.41-0.94,8.47-3.06,12.29c-2.85,5.14-6.8,9.33-11.42,12.87 c-13.42,10.29-28.8,15.28-45.5,16.48c-5.62,0.4-11.25,0.13-16.81-0.99c-5.51-1.11-10.79-2.84-15.42-6.13 c-6.57-4.67-9.92-10.86-8.7-19.1c0.14-0.92,0.37-1.83,0.56-2.74c-0.04-0.02-0.09-0.03-0.13-0.05c-0.18,0.44-0.37,0.88-0.54,1.33 c-0.98,2.55-1.68,5.19-2.24,7.86c-1.08,5.19-0.41,9.96,2.08,14.28C97.71,126.36,101.79,129.87,103.06,134.71z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.19,129.71c0.1-0.01,0.19-0.02,0.29-0.03C90.38,129.69,90.28,129.7,90.19,129.71z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152987260868006794510000003636004708392533399_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.312,
    y1: 137.069,
    x2: 206.4753,
    y2: 137.069
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E9B69C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#FBD9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    style: {
      stopColor: "#8F9A9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152987260868006794510000003636004708392533399_)"
    },
    d: "M198.74,118.62 c-3.85,5.55-8.75,10.05-14.29,13.83c-15.02,10.22-31.76,15.3-49.81,16.25c-6.06,0.32-12.11-0.09-18.08-1.36 c-4.94-1.05-9.68-2.56-14-5.03c-0.22,0.55-0.47,1.1-0.78,1.62c-0.89,1.52-2.08,2.79-3.47,3.77c3.76,3.24,8.15,5.42,12.88,6.98 c9.82,3.25,19.91,3.81,30.14,2.87c5.73-0.52,11.38-1.53,16.93-3.06c13.78-3.79,26.46-9.71,37.08-19.51 c4.17-3.85,7.71-8.21,10.14-13.38c0.38-0.8,0.7-1.62,1.01-2.43c-2.33-0.39-4.47-1.45-6.17-3C199.81,117,199.3,117.82,198.74,118.62 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182519224150796031040000006340605223867062440_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.0173,
    y1: 145.4266,
    x2: 210.491,
    y2: 145.4266
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E9B69C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#FBD9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    style: {
      stopColor: "#8F9A9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182519224150796031040000006340605223867062440_)"
    },
    d: "M209.47,120.67 c-0.7,4.55-2.57,8.62-5.13,12.39c-4.09,6.03-9.41,10.81-15.37,14.91c-8.44,5.79-17.7,9.83-27.52,12.64 c-7.62,2.18-15.4,3.46-23.32,3.78c-4.16,0.17-8.32,0.04-12.47-0.45c-5.85-0.69-11.54-1.99-16.94-4.38 c-4.71-2.09-8.89-4.91-12.16-8.97c-0.36-0.45-0.69-0.93-1.01-1.41c-0.17,0.06-0.36,0.11-0.54,0.17c0.63,1.37,1.34,2.7,2.02,4.05 c3.04,6.05,7.86,10.16,13.87,13.01c7.07,3.35,14.6,4.78,22.34,5.16c5.72,0.28,11.42,0,17.09-0.85 c11.81-1.78,23.02-5.36,33.48-11.17c7.57-4.21,14.37-9.39,19.75-16.28c3.04-3.89,5.3-8.17,6.39-13.04 c0.82-3.66,0.51-7.34,0.32-11.01c-0.21,0.03-0.41,0.05-0.62,0.07C209.6,119.73,209.54,120.2,209.47,120.67z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012467502051756176720000003778652874159384973_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.281,
    y1: 159.8062,
    x2: 208.6258,
    y2: 159.8062
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E9B69C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#FBD9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    style: {
      stopColor: "#8F9A9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012467502051756176720000003778652874159384973_)"
    },
    d: "M208.15,139.76 c-1.04,2.79-2.44,5.39-4.17,7.8c-3.99,5.56-9.01,10.05-14.72,13.74c-14.67,9.49-30.8,14.25-48.23,14.71 c-5.68,0.15-11.3-0.3-16.85-1.6c-6.02-1.41-11.68-3.62-16.56-7.55c-0.05-0.04-0.15-0.02-0.33-0.05c0.15,0.19,0.23,0.3,0.33,0.4 c5.28,5.41,11.42,9.37,18.82,11.3c8.4,2.2,16.9,2.49,25.47,1.46c10.89-1.32,21.22-4.48,30.9-9.66c5.43-2.91,10.38-6.46,14.78-10.79 c4.82-4.75,8.01-10.45,10.01-16.87c0.36-1.17,0.7-2.35,1.04-3.53c-0.07-0.02-0.13-0.05-0.2-0.07 C208.33,139.29,208.24,139.52,208.15,139.76z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072265963992789827420000013671457684929997996_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.2818,
    y1: 173.1775,
    x2: 196.9121,
    y2: 173.1775
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E9B69C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2598,
    style: {
      stopColor: "#FBD9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    style: {
      stopColor: "#8F9A9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072265963992789827420000013671457684929997996_)"
    },
    d: "M164.95,180.06 c-12.15,3.24-24.38,3.94-36.67,0.45c0.15,0.07,0.29,0.16,0.45,0.22c8.2,3.08,16.65,4.27,25.38,3.42c5.91-0.58,11.66-1.9,17.25-3.91 c9.99-3.59,18.44-9.36,25.21-17.56c0.15-0.18,0.37-0.33,0.35-0.72C188.07,171.33,177.11,176.81,164.95,180.06z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M121.92,95.24c4.62,1.61,9.38,1.83,14.2,1.27c6.37-0.74,12.33-2.71,17.76-6.15c3.61-2.29,6.76-5.09,8.65-9.03 c1.33-2.77,1.61-5.62,0.26-8.48c-1.05-2.22-2.81-3.75-4.93-4.9c-3.9-2.11-8.14-2.7-12.49-2.75c-1.04-0.01-2.07,0.06-3.1,0.14 c-6.61,0.55-12.79,2.45-18.47,5.88c-3.61,2.18-6.76,4.87-8.87,8.61c-2.17,3.85-2.02,7.96,0.47,11.08 C117.1,93.04,119.38,94.35,121.92,95.24z M121.17,77.6c1.62-2.76,4.02-4.7,6.74-6.26c4.63-2.64,9.63-3.96,14.41-4.02 c3.28,0.02,5.94,0.39,8.44,1.52c2.42,1.1,4.37,2.68,4.97,5.44c0.47,2.16-0.18,4.09-1.33,5.89c-1.94,3.02-4.75,5.04-7.9,6.61 c-4.52,2.26-9.32,3.38-14.38,3.23c-2.78-0.08-5.48-0.59-7.96-1.94c-2.2-1.2-3.8-2.88-4.18-5.46 C119.74,80.8,120.27,79.14,121.17,77.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018958595072872744650000016585306465415449778_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.935,
    y1: 78.677,
    x2: 155.902,
    y2: 78.677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D71B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1397,
    style: {
      stopColor: "#3FB1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5056,
    style: {
      stopColor: "#CAFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6966,
    style: {
      stopColor: "#89DAFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8994,
    style: {
      stopColor: "#3FB1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1D71B8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018958595072872744650000016585306465415449778_)"
    },
    d: "M124.18,88.08 c2.48,1.35,5.18,1.86,7.96,1.94c5.06,0.14,9.87-0.98,14.38-3.23c3.14-1.57,5.95-3.59,7.9-6.61c1.15-1.8,1.8-3.73,1.33-5.89 c-0.6-2.76-2.55-4.34-4.97-5.44c-2.5-1.13-5.16-1.51-8.44-1.52c-4.78,0.06-9.78,1.37-14.41,4.02c-2.72,1.55-5.13,3.5-6.74,6.26 c-0.91,1.54-1.44,3.2-1.17,5.01C120.38,85.2,121.98,86.88,124.18,88.08z M131.05,75.07c2.42-2.24,5.36-3.12,8.59-3.2 c1.25-0.02,2.47,0.13,3.62,0.66c2.36,1.09,2.91,3.19,1.38,5.3c-0.56,0.77-1.25,1.43-2.07,1.93c-3.02,1.86-6.26,2.69-9.79,1.89 c-1.45-0.33-2.79-0.96-3.24-2.52C129.07,77.47,129.87,76.15,131.05,75.07z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000133502613566547369610000014952033015357793679_",
    cx: 208.3214,
    cy: 107.1797,
    r: 7.6683,
    fx: 206.1985,
    fy: 102.3436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    style: {
      stopColor: "#BEE4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3FB1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1D71B8"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000133502613566547369610000014952033015357793679_)"
    },
    cx: 208.32,
    cy: 107.18,
    r: 7.67
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000092446303963692178060000014787589207831411106_",
    cx: 91.3341,
    cy: 137.8181,
    r: 7.6683,
    fx: 92.2672,
    fy: 131.8588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    style: {
      stopColor: "#BEE4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3FB1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1D71B8"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000092446303963692178060000014787589207831411106_)"
    },
    cx: 91.33,
    cy: 137.82,
    r: 7.67
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165923361419486317770000006580955012766132394_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.8276,
    y1: 84.908,
    x2: 173.2533,
    y2: 84.908
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D71B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1397,
    style: {
      stopColor: "#3FB1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5056,
    style: {
      stopColor: "#CAFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6966,
    style: {
      stopColor: "#89DAFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8994,
    style: {
      stopColor: "#3FB1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1D71B8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165923361419486317770000006580955012766132394_)"
    },
    d: "M106.44,94.39 c1.25,3.87,4.05,6.4,7.54,8.24c5,2.64,10.43,3.45,16,3.54c3.13,0.05,6.25-0.25,9.34-0.79c8.41-1.48,16.23-4.4,23.16-9.46 c3.92-2.86,7.29-6.25,9.35-10.74c1.25-2.72,1.8-5.57,1.14-8.55c-0.88-3.93-3.35-6.67-6.66-8.73c0,0-4.3-3.6-18.72-4.24 c-9.71-0.43-21.31,4.71-21.31,4.71c-2.65,1.12-5.17,2.51-7.58,4.08c-4.33,2.83-8.15,6.19-10.73,10.76 C105.99,86.72,105.16,90.44,106.44,94.39z M114.89,79.83c2.11-3.74,5.26-6.43,8.87-8.61c5.68-3.43,11.86-5.33,18.47-5.88 c1.03-0.09,2.06-0.15,3.1-0.14c4.35,0.05,8.59,0.63,12.49,2.75c2.12,1.15,3.88,2.68,4.93,4.9c1.35,2.86,1.07,5.71-0.26,8.48 c-1.89,3.95-5.03,6.74-8.65,9.03c-5.43,3.45-11.38,5.41-17.76,6.15c-4.82,0.56-9.58,0.34-14.2-1.27c-2.54-0.88-4.82-2.2-6.52-4.33 C112.87,87.79,112.72,83.68,114.89,79.83z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNormal);
export default __webpack_public_path__ + "static/media/logo-normal.b0843fa86f1a4b03e766af8b98c12d3f.svg";
export { ForwardRef as ReactComponent };